import React, { useEffect } from 'react';
import { makeVar, useReactiveVar } from '@apollo/client';
import { PaymentCycleList } from './list';
import { PayCycleAccEntryList } from './AccountingEntry/list';
import { globalMode } from 'utility/cache/ui';

export type PayCycleView = 'Signing' | 'Accounting' | 'History';

export const payCycleMode = makeVar<PayCycleView>('Signing');

export const PayCycle: React.FC = () => {
  const payCycleState = useReactiveVar(payCycleMode);
  
  const globalState = useReactiveVar(globalMode);

  if (!payCycleState && globalState) payCycleMode('Signing');
  // defaulting to Pay Cycle list after Route change
  useEffect(() => {
    return () => {
      payCycleMode('Signing');
    };
  }, []);

 const mode = useReactiveVar(payCycleMode);

return (
  <>
    {mode === 'Signing' && <PaymentCycleList />}
    {(mode === 'Accounting' || mode === 'History') && (
      <PayCycleAccEntryList />
    )}
  </>
);
};
